module.exports = __webpack_public_path__ + "img/744.7520e9a5.jpg";